import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            meta: { title: '中国市场出版社',bookShow:true,telShow:true },
            component: () => import ('@/views/index'),
        }, 
        {
            path: '/news',
            name: 'news',
            meta: { title: '动态',bookShow:true,telShow:true },
            component: () => import ('@/views/news/index'),
        },
        {
            path: '/newsDetail',
            name: 'newsDetail',
            meta: { title: '新闻详情' },
            component: () => import ('@/views/news/detail'),
        },
        {
            path:'/bookOrderingList',
            name:'bookOrderingList',
            meta: { title: '图书订购',telShow:true },
            component: () => import ('@/views/bookOrderingList/index'),
        },
        {
            path: '/book',
            name: 'book',
            meta: { title: '新书',bookShow:true,telShow:true },
            component: () => import ('@/views/book/index'),
        },
        {
            path: '/detail',
            name: 'detail',
            meta: { title: '图书详情',telShow:true },
            component: () => import ('@/views/book/detail'),
        },
        {
            path: '/down',
            name: 'down',
            meta: { title: '下载',bookShow:true,telShow:true },
            component: () => import ('@/views/down/index'),
        },
        {
            path: '/pic',
            name: 'pic',
            meta: { title: '图文',bookShow:true,telShow:true},
            component: () => import ('@/views/pic/index'),
        },
        {
            path: '/picdetail',
            name: 'picdetail',
            meta: { title: '图文' },
            component: () => import ('@/views/pic/detail'),
        },
        {
            path: '/about',
            name: 'about',
            meta: { title: '关于',bookShow:true,telShow:true },
            component: () => import ('@/views/about/index'),
        },
        {
            path: '/search',
            name: 'search',
            meta: { title: '搜索' },
            component: () => import ('@/views/resource/search'),
        }, 
        {
            path: '/searchResult',
            name: 'searchResult',
            meta: { 
                title: '搜索结果',
            },
            component: () => import ('@/views/searchResult/index'),
        },
        {
            path: '/cart',
            name: 'cart',
            meta: { 
                title: '购物车',
            },
            component: () => import ('@/views/cart/index'),
        },
        {
            path: '/my',
            name: 'my',
            meta: { title: '我的' },
            component: () => import ('@/views/myperson/index'),
        },
        {
            path: '/order',
            name: 'order',
            meta: { title: '我的订单' },
            component: () => import ('@/views/order/index'),
        },
        {
            path: '/confirmOrder',
            name: 'confirmOrder',
            meta: { title: '确认订单' },
            component: () => import ('@/views/order/confirmOrder'),
        },
        {
            path: '/address/index',
            name: 'address',
            meta: { title: '地址' },
            component: () => import ('@/views/address/index'),
        },
        {
            path: '/address/manage',
            name: 'manage',
            meta: { title: '地址' },
            component: () => import ('@/views/address/manage'),
        },
        {
            path: '/address/change',
            name: 'change',
            meta: { title: '地址' },
            component: () => import ('@/views/address/change'),
        },
        {
            path: '/orderDetail',
            name: 'orderDetail',
            meta: { title: '订单详情' },
            component: () => import ('@/views/order/orderDetail'),
        },
        {
            path: '/paymentOrder',
            name: 'paymentOrder',
            meta: { title: '订单支付' },
            component: () => import ('@/views/order/paymentOrder'),
        },
        {
            path: '/paymentSuccessful',
            name: 'paymentSuccessful',
            meta: { title: '支付成功' },
            component: () => import ('@/views/order/paymentSuccessful'),
        },
        {
            path: '/edit',
            name: 'edit',
            meta: { title: '个人信息' },
            component: () => import ('@/views/myperson/edit'),
        }, 
        {
            path: '/set',
            name: 'set',
            meta: { title: '我的设置' },
            component: () => import ('@/views/myperson/set'),
        }, {
            path: '/password',
            name: 'password',
            meta: { title: '修改密码' },
            component: () =>  import ('@/views/myperson/password'),
        }, {
            path: '/verify',
            name: 'verify',
            meta: { title: '验证手机' },
            component: () =>  import ('@/views/myperson/verify'),
        },
        {
            path: '/login',
            name: 'login',
            redirect: '/login/sign',
            component: () => import('@/views/login/index.vue'),
            children: [
                //登录
                {
                    path: 'sign',
                    name: 'sign',
                    meta: {title: '登录',isRight: true},
                    component: () => import('@/views/login/signIn.vue')
                },
                {
                    path: 'setPassword',
                    name: 'setPassword',
                    meta: { title: '设置密码',isRight: true },
                    component: () => import("@/views/login/setPassword.vue"),
                },
                // {
                //     path: 'organizaRegistr',
                //     name: 'organizaRegistr',
                //     meta: { title: '注册' },
                //     component: () => import("@/views/login/organizaRegistr.vue"),
                // },
                {
                    path: 'retrieve',
                    name: 'retrieve',
                    meta: { title: '找回密码',isRight: true },
                    component: () => import("@/views/login/retrieve.vue"),
                },
                {
                    path: 'binding',
                    name: 'binding',
                    meta: { title: '绑定' },
                    component: () => import("@/views/login/binding.vue"),
                },
                {
                    path: 'agree',
                    name: 'agree',
                    meta: { title: '用户协议',isRight: true },
                    component: () => import("@/views/login/agree.vue"),
                },
                {
                    path: 'agreeYinsi',
                    name: 'agreeYinsi',
                    meta: { title: '用户隐私',isRight: true },
                    component: () => import("@/views/login/agreeYinsi.vue"),
                },
            ]}, 
        {
            path: '*',
            meta: { title: '中国市场出版社' },
            component: () => import ('@/views/index'),
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js